import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TablesAgGridRoutingModule } from './tables-ag-grid-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TablesAgGridRoutingModule,
  ]
})
export class TablesAgGridModule { }
